// Module
var code = "<div class=\"dropdown\"> <a title=\"Basket\" class=\"btn btn blue-sharp\" data-toggle=\"dropdown\"> <i class=\"fa fa-shopping-basket\"></i> <span class=\"badge\">4</span> </a> </div>";
// Exports
export default code;